import React, { useState } from "react";
import { Link } from "react-router-dom";
import { NavLink } from "react-router-dom";

function MainMenu() {
    const [menuOpen, setMenuOpen] = useState(false);
    const [moreOpen, setMoreOpen] = useState(false);

    const closeMenu = () => {
        setMenuOpen(false);
    };

    return (
        <div style={{ width: "100%" }}>
            <div className="row menubar align-items-center" >

                {/* LOGO */}
                {/* <div className="col-md-4 col-8">
                    <div style={{ paddingLeft: "10%", paddingTop: "10px", paddingBottom: "10px" }}>
                        <div style={{ float: 'left', width: '80px', padding: '10px' }}>
                            <img src="./images/ayappan.png" style={{ width: "100%" }} alt="logo" />
                        </div>
                        <div style={{ float: 'left', paddingTop: '20px' }}>
                            <span className="templename">
                                Ayyappa Temple Borivili
                            </span> <br />
                            
                        </div>
                    </div>
                </div> */}
                    
                <div className="col-md-4 col-8" >
                    <div className="container">
                        <div className="row">
                            {/* <div className="col-md-4 col-4">
                                <div style={{height:'50px',width:'100%',display:'flex',alignItems:'center',justifyContent:'end' }}>
                                    <img src="./images/bannerimage.png" style={{ height: "60%" }} alt="logo" />
                                </div>
                            </div> */}
                            <div className="col-md-12 col-12" style={{display:'flex',alignItems:'center',justifyContent:'end',height:'50px'}}>
                            <img src="./images/bannerimage.png" style={{ height: "60%" }} alt="logo" />
                                <span className="templename">
                                Sree Ayyappa Temple Borivili
                                </span>

                            </div>
                        </div>
                    </div>
                </div>

                {/* HAMBURGER BUTTON (Mobile only) */}
                <div className="col-4 d-md-none text-end pe-4">
                    <button
                        className="btn btn-outline-warning humberger"
                        onClick={() => setMenuOpen(!menuOpen)}
                    >
                        ☰
                    </button>
                </div>

                {/* MENU ITEMS */}
                {/* MENU ITEMS */}
                <div className={`col-md-8 menu-wrapper ${menuOpen ? "show" : ""}`}>
                    <div className="container containeritems">

                        <div className="boxes">
                            <NavLink to="/" className={({ isActive }) =>
                                "menuitems " + (isActive ? "active-menu" : "")
                            } onClick={closeMenu}>
                                Home
                            </NavLink>
                        </div>

                        <div className="boxes">
                            <NavLink to="/History"
                                onClick={closeMenu}
                                className={({ isActive }) =>
                                    "menuitems " + (isActive ? "active-menu" : "")
                                } >
                                History
                            </NavLink>
                        </div>

                        <div className="boxes">
                            <a
                                href="https://booking.ayyappatempleborivili.in/"
                                className="menuitems"
                                onClick={closeMenu}
                            >
                                Online Booking
                            </a>
                        </div>

                        <div className="boxes">
                            <NavLink to="/Timing" className={({ isActive }) =>
                                "menuitems " + (isActive ? "active-menu" : "")
                            } onClick={closeMenu}>
                                Temple Festivals
                            </NavLink>
                        </div>

                        <div className="boxes">
                            <NavLink to="/Administration" className={({ isActive }) =>
                                "menuitems " + (isActive ? "active-menu" : "")
                            } onClick={closeMenu}>
                                Administration
                            </NavLink>
                        </div>

                        <div className="boxes">
                            <NavLink to="/Founders" className={({ isActive }) =>
                                "menuitems " + (isActive ? "active-menu" : "")
                            } onClick={closeMenu}>
                                Founder Trustees
                            </NavLink>
                        </div>

                        <div className="boxes more-menu">
                            <div
                                className="menuitems"
                                onClick={() => setMoreOpen(!moreOpen)}
                                style={{ cursor: "pointer" }}
                            >
                                More ▾
                            </div>

                            {moreOpen && (
                                <div className="submenu">
                                    <NavLink to="/Gallery" className={({ isActive }) =>
                                        "submenu-item " + (isActive ? "active-menu" : "")
                                    } onClick={() => { closeMenu(); setMoreOpen(false); }}>
                                        Gallery
                                    </NavLink>

                                    <NavLink to="/NandanamHall" className={({ isActive }) =>
                                        "submenu-item " + (isActive ? "active-menu" : "")
                                    } onClick={() => { closeMenu(); setMoreOpen(false); }}>
                                        Nandanam Hall
                                    </NavLink>

                                    <NavLink to="/Contact" className={({ isActive }) =>
                                        "submenu-item " + (isActive ? "active-menu" : "")
                                    } onClick={() => { closeMenu(); setMoreOpen(false); }}>
                                        Contact
                                    </NavLink>

                                </div>
                            )}
                        </div>



                    </div>
                </div>
            </div>
            {/* <div style={{ width: '150px', height: '150px', position: 'fixed', bottom: '0', right: '0', marginRight: '50px', marginBottom: '180px' }}>
                <a href="https://booking.panchamidevi.in/"> <img src="./images/online-booking.png" alt="Online Booking" style={{ width: '100%', border: '4px solid white', borderRadius: '10px' }} /></a>
            </div> */}



        </div>
    );
}

export default MainMenu;
